import React from 'react';
import { Chip } from '@mui/material';
import { IPD_COLORS } from '../theme';
import { invChipSx } from './StatusChip';

export default function ModuleBadge({ itemType, isPharmacy }) {
  const isPharma = isPharmacy ?? itemType === 'MEDICINE';
  return (
    <Chip
      label={isPharma ? 'PHARMACY' : 'INVENTORY'}
      size="small"
      sx={invChipSx({
        color: isPharma ? IPD_COLORS.primary : IPD_COLORS.success.text,
        variant: 'soft',
        size: 'xs',
      })}
    />
  );
}
